import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useGetConfig } from "../../../../api/config";
import { useGetWebUrlDetail } from "../../../../api/webUrls";
import { Head } from "../../../../Components/public/Navbar";
import WebUrlIframe from "../../../../Components/public/WebUrlIframe/WebUrlIframe";
import { paths } from "../../../../routes/paths";

import "../../../../layouts/ImmersiveLayout.css";
import styles from "./WebUrlView.module.css";

const getWebUrlSrc = webUrl => {
  if (!webUrl) return "";
  if (typeof webUrl === "object") return webUrl.url || "";
  return typeof webUrl === "string" ? webUrl : "";
};

const WebUrlView = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { data: config } = useGetConfig();
  const { data: webUrl, isLoading } = useGetWebUrlDetail(id);

  const src = getWebUrlSrc(webUrl) || getWebUrlSrc(state?.item);
  const title = webUrl?.name || state?.item?.name || "Web URL";

  useEffect(() => {
    const html = document.documentElement;
    const root = document.getElementById("root");
    const original = {
      htmlOverflow: html.style.overflow,
      htmlHeight: html.style.height,
      bodyOverflow: document.body.style.overflow,
      bodyHeight: document.body.style.height,
      bodyWidth: document.body.style.width,
      bodyOverscroll: document.body.style.overscrollBehavior,
      rootOverflow: root?.style.overflow,
      rootHeight: root?.style.height,
    };

    html.style.overflow = "hidden";
    html.style.height = "100%";
    document.body.style.overflow = "hidden";
    document.body.style.height = "100%";
    document.body.style.width = "100%";
    document.body.style.overscrollBehavior = "none";
    if (root) {
      root.style.overflow = "hidden";
      root.style.height = "100%";
    }

    return () => {
      html.style.overflow = original.htmlOverflow;
      html.style.height = original.htmlHeight;
      document.body.style.overflow = original.bodyOverflow;
      document.body.style.height = original.bodyHeight;
      document.body.style.width = original.bodyWidth;
      document.body.style.overscrollBehavior = original.bodyOverscroll;
      if (root) {
        root.style.overflow = original.rootOverflow;
        root.style.height = original.rootHeight;
      }
    };
  }, []);

  return (
    <div className="immersive-layout">
      <Head title={title} favicon={config?.data?.favicon} />
      <button
        type="button"
        className={styles.backButton}
        onClick={() => navigate(paths.admin.webUrls.root)}
      >
        Back
      </button>
      <div className="immersive-layout__scene">
        {!isLoading && src ? (
          <WebUrlIframe
            src={src}
            title={title}
            className="immersive-layout__iframe"
          />
        ) : (
          <div className="immersive-layout immersive-layout--empty">
            <p>{isLoading ? "Loading..." : "No URL available."}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default WebUrlView;
